// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2dQPU","legacyBtn":"MutateMid_legacyBtn__1asN2"};